import { MembershipRenewInterval } from "./MembershipRenewInterval";
import InvoiceInfoJson from "./InvoiceInfoJson";
import { Validation, ValidationErrorType } from "./Validation";

export default interface MembershipTermJson {
   /**
    * Beginn des Mitgliedschaftszeitraums
    */
   beginDate: string;

   /**
    * Beginn des Mitgliedschaftszeitraums
    */
   endDate: string;

   /**
    * Mitgliedschaftsbeitrag, Förderbeitrag, Versicherungsbeitrag in Eurocent.
    */
   price: number | null;

   /**
    * Gibt an, ob für diesen Zeitraum noch eine Zahlung exportiert werden soll
    */
   needsPaymentExport: boolean;

   /**
     * Rechnungsinformationen wie Rechnungsnummer.
     */
   invoiceInfos: InvoiceInfoJson[] | null;
}

export function validateMembershipTermJson(item: MembershipTermJson) {
   return new Validation(item)
      .validateDate("beginDate")
      .validateDateLater("endDate", "beginDate")
      .validateInteger("price", 0, null)
      .finish();
}
export function validateMembershipTermJsonArraySequential(items: MembershipTermJson[]) {

   let validations = [];
   let previousElement: MembershipTermJson | null = null;

   for (var item of items) {
      var validation = new Validation(item)
         .validateDate("beginDate")
         .validateDateLater("endDate", "beginDate")
         .validateInteger("price", 0, null);

      if (previousElement && previousElement.beginDate > item.endDate) {
         validation.set("beginDate", ValidationErrorType.invalidDate);
      }

      validations.push(validation.finish());
      previousElement = item;
   }

   return validations;
}

export function getNextMembershipTerm(membershipTerms: MembershipTermJson[], renewInterval: MembershipRenewInterval, price: number | null): MembershipTermJson {
   var firstMembershipDay = new Date();
   if (membershipTerms.length > 0) {
      let endDates = membershipTerms.map(t => new Date(t.endDate).getTime());
      firstMembershipDay = new Date(Math.max(...endDates));
      firstMembershipDay.setDate(firstMembershipDay.getDate() + 1);
   } else {
      firstMembershipDay.setDate(1);
      if (renewInterval == MembershipRenewInterval.biannual && firstMembershipDay.getMonth() >= 6) {
         firstMembershipDay.setMonth(6);
      } else {
         firstMembershipDay.setMonth(0);
      }
   }
   firstMembershipDay.setHours(0);
   firstMembershipDay.setMinutes(0);
   firstMembershipDay.setSeconds(0);
   firstMembershipDay.setMilliseconds(0);

   var lastMembershipDay = new Date(firstMembershipDay);
   if (renewInterval == MembershipRenewInterval.biannual) {
      lastMembershipDay.setMonth(lastMembershipDay.getMonth() + 6);
      lastMembershipDay.setDate(lastMembershipDay.getDate() - 1);
   } else {
      lastMembershipDay.setMonth(lastMembershipDay.getMonth() + 12);
      lastMembershipDay.setDate(lastMembershipDay.getDate() - 1);
   }
   lastMembershipDay.setHours(23);
   lastMembershipDay.setMinutes(59);
   lastMembershipDay.setSeconds(59);
   lastMembershipDay.setMilliseconds(0);

   var formatISODate = function (date: Date): string {
      //return 2020-09-23
      function pad2(t: number) {
         var s = "00" + t;
         return s.substr(s.length - 2);
      }
      return (
         date.getFullYear() +
         "-" +
         pad2(date.getMonth() + 1) +
         "-" +
         pad2(date.getDate())
      );
   };
   let term: MembershipTermJson = {
      beginDate: formatISODate(firstMembershipDay),
      endDate: formatISODate(lastMembershipDay),
      price: price,
      needsPaymentExport: true,
      invoiceInfos: null
   };
   return term as any;
}